import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ScreenState } from '@src/app/enums';
import { getAssetAllocationAsync } from './thunks';
import { AssetAllocationData, AssetCardDetails, AssetChartDetails } from './types';
import fusionChartPaletteColors from '@src/app/constants/paletteColors';
import { AssetClassList, PortfoliosAssetAllocation } from 'clientportalshared';
import { DateTime } from 'luxon';

export interface AssetAllocationStore {
  state: ScreenState;
  data: AssetClassList;
  view: AssetAllocationData;
  totalValue: number;
}

const initialState: AssetAllocationStore = {
  state: ScreenState.Loading,
  asOfDate: DateTime.now().toISODate(),
  data: {},
  view: {
    cards: [],
    charts: [],
  },
  totalValue: 0,
} as AssetAllocationStore;

export const AssetAllocationSlice = createSlice({
  name: 'assetAllocation',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAssetAllocationAsync.pending, (state) => {
      state.state = ScreenState.Loading;
    });
    builder.addCase(getAssetAllocationAsync.rejected, (state) => {
      state.state = ScreenState.ErrorUnableToLoadData;
    });
    builder.addCase(getAssetAllocationAsync.fulfilled, (state, action: PayloadAction<PortfoliosAssetAllocation>) => {
      const assetClassInfo = action.payload.data || [];
      const assetClassCharts: AssetChartDetails[] = [];
      const assetClassCards: AssetCardDetails[] = [];

      for (let index = 0; index < assetClassInfo.length; index++) {
        const assetClass = assetClassInfo[index];
        const assignedColor = fusionChartPaletteColors[index % fusionChartPaletteColors.length];
        assetClassCharts.push({ label: assetClass.name || '', value: assetClass.value || '', color: assignedColor });
        assetClassCards.push({ color: assignedColor, assetClass: assetClass });
      }
      state.view = {
        charts: assetClassCharts,
        cards: assetClassCards,
      };
      state.data = action.payload;
      state.totalValue = action.payload.totalValue || 0;
      state.state = ScreenState.SuccessDataLoaded;
    });
  },
});

export default AssetAllocationSlice.reducer;
